import React, { PureComponent } from 'react'
import { number } from 'prop-types'
import { TableCell } from './TableCell'

export class SpeedTableCell extends PureComponent {
    static propTypes = {
        average: number,
        percentage: number,
        max: number,
        min: number
    }

    render() {
        const { average, percentage, max, min, ...otherProps } = this.props
        const percentageFrom20 = !isNaN(percentage) ? 20 + (0.8 * percentage) : 0
        return (
            <TableCell className="Speed" {...otherProps}>
                <div className="TableCell-Speed flex row-stretch">
                    <div className="TableCell-Speed-Bar" style={{ width: `${percentageFrom20}%` }}>
                        {numberToStr(average)}
                    </div>
                    <div className="TableCell-Speed-Values flex col-stretch-left" style={{ left: `${percentageFrom20}%` }}>
                        <div>{numberToStr(max)}</div>
                        <div>{numberToStr(min)}</div>
                    </div>
                </div>
            </TableCell>
        )
    }
}

function numberToStr(num) {
    return (typeof num === 'number' ? num.toFixed(1).replace('.0', '') : num) || ''
}



// WEBPACK FOOTER //
// src/components/Table/SpeedTableCell.js